/* eslint-disable no-console */
import { ApiClientInstance } from '@shared/api';

import { TFeaturesResponse } from '../types';

export const getUserFeatures = async (token: string): Promise<TFeaturesResponse> => {
  if (!token) return [];
  try {
    const userFeatures = await ApiClientInstance.get<TFeaturesResponse>('v2/management/features', {
      anonymouse: true,
      headers: {
        Authorization: `Bearer ${token}`,
        'oauth-access-token': `${token}`,
      },
    });
    console.info('[FeatureFlags] Feature flags successfully fetched ', {
      userFeatures,
    });

    return userFeatures;
  } catch (error) {
    console.error('[FeatureFlags] Error fetching feature flags:', error);
    return [];
  }
};

export const getEmergencyFeatures = async (token: string): Promise<string[]> => {
  if (!token) return [];

  try {
    const userFeatures = await ApiClientInstance.get<string[]>('v2/management/features/emergency', {
      anonymouse: true,
      headers: {
        Authorization: `Bearer ${token}`,
        'oauth-access-token': `${token}`,
      },
    });
    console.info('[EmergencyFeatureFlags] Feature flags successfully fetched.', {
      userFeatures,
    });

    return userFeatures;
  } catch (error) {
    console.error('[EmergencyFeatureFlags] Error fetching emergency feature flags:', error);
    return [];
  }
};
